import { Box, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import OfflineStorage from "../../../../common/offlineStorage/OfflineStorage";
import { useRouteToFlowStartPage } from "../../hooks/useRouteToFlowStartPage";
import { useLogoRect } from "../../hooks/useLogoRect";
import colors from "common/styles/colors";

const useStyles = makeStyles({
  logoContainer: {
    width: "100%",
    maxWidth: 706,
    display: "flex",
    alignItems: "center"
  },
  logo: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
    cursor: "pointer"
  }
});

export const CompanyLogo = () => {
  const [logoSrc, setLogoSrc] = useState("");
  const { routeToFlowStartPage } = useRouteToFlowStartPage();
  const classes = useStyles();
  const { height } = useLogoRect();
  const isTablet = useMediaQuery("(max-width:834px), (max-height:834px)");

  const configureLogoSrc = async () => {
    const src = await OfflineStorage.getEventLogoFromStorage();
    setLogoSrc(src);
  };

  useEffect(() => {
    configureLogoSrc();
  }, []);

  const onLogoClick = () => {
    routeToFlowStartPage();
  };

  if (!logoSrc) return null;

  return (
    <Box className={classes.logoContainer}>
      <Box
        sx={{
          width: "100%",
          maxWidth: 706,
          height,
          mx: "auto",
          bgcolor: colors.white,
          mb: isTablet ? "10px" : "20px"
        }}
      >
        <img data-testid="logo" src={logoSrc} alt="logo" onClick={onLogoClick} className={classes.logo} />
      </Box>
    </Box>
  );
};
